import { render, staticRenderFns } from "./OrphanDevicesPanel.vue?vue&type=template&id=32f660bb&scoped=true"
import script from "./OrphanDevicesPanel.vue?vue&type=script&lang=js"
export * from "./OrphanDevicesPanel.vue?vue&type=script&lang=js"
import style0 from "./OrphanDevicesPanel.vue?vue&type=style&index=0&id=32f660bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f660bb",
  null
  
)

export default component.exports